<section class="jio-share-main pseudo-tab" [ngClass]="[(!universalService.isMobileDevice && universalService.emptyTabViewRequiresMenu && universalService?.viewIsTabOriented) ? 'empty-tabbed-view-selection-menu' : '']">
  <div class="prelogin-sharing-main">
    <div [ngClass]="[tabDetails.length > 0 ? 'jiocloud-sharing-holder' : '']">
      @if (tabDetails.length > 0 && !universalService.hideTabs) {
        <div class="sharing-tabs-main">
          <div class="col-sm pl-0 pr-0" >
            @if (showSlider || currentView == 'Albums') {
              <div id="tabs" class="nav-tabs" [ngClass]="[universalService.inAppWebViewOpened ? 'webview-nav-tabs' : '',universalService.activeRepo == 'enterprise' ? 'ent-tabbed-view' : '']" >
                <nav aria-labelledby="tabs" class="slidemenu" [ngClass] = "[(tabDetails.length >=5 && universalService.isMobileDevice) ? 'add-padding-left-right' : '']">
                  @for (tab of tabDetails; track tab) {
                    <div class="filter-name" [ngStyle]="{'width':(universalService.isMobileDevice) ? (100/tabDetails.length + '%') : ''}">
                      <input type="radio" name="{{tab.slideItemClass}}" id="{{tab.slideItemClass}}" class="slide-toggle1"/>
                      <label id="{{tab.id}}" for="{{tab.slideItemClass}}" class="tabbed-label {{tabViewClassForDevice}}" [ngClass]="router.url.includes('/shared') && universalService.userLoggedIn ? 'share-tab-label': ''">
                        <div class="m-alignment d-inline-block no-focus" (click)="switchTab(tab,true)"  [ngClass]="tab.id == 'albumFiles' && this.universalService.showFeaturesForEntUsers == true ? 'hideOption' : ''">
                          @if (tab.iconName!='') {
                            <span class="iconClass {{tab.iconName}}"></span>
                            }{{tab.name}}
                          </div>
                        </label>
                      </div>
                    }
                  </nav>
                </div>
              }
              @if ( universalService.showTabSlider || (currentView != 'Trash' && currentView != 'Profile' && showSlider && universalService.selectedTab != 'Albums Detais' && universalService.selectedTab != 'Profile' && universalService.userLoggedIn && !shareAccessService.invalidUnivShareKey)) {
                <div class="slider d-none d-lg-block" ></div>
              }
            </div>
          </div>
        }

        <!-- Mobile Only - Teams folder dropdown -->
        @if (tabDetails.length > 0 && universalService.isMobileDevice) {
          <div [ngClass]="[tabDetails.length > 0 ? 'm-3' : '']">
            @if (tabDetails.length > 0 && universalService.hideTabs) {
              <div class="m-teams-dropdown mb-2 d-block d-lg-none">
                <div class="drop-head dropdown-toggle" (click)="showHideTabbedViewDropDown($event)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{currentTab}} <span class="NeueExpand float-right mt-1"></span>
                </div>
                <div class="drop-menu dropdown-menu" >
                  @for (tab of tabDetails; track tab) {
                    <ul>
                      @if (currentTab != tab.name) {
                        <li (click)="switchTab(tab,true)">{{tab.name}}</li>
                      }
                    </ul>
                  }
                </div>
              </div>
            }
          </div>
        }

        @if (scrollToTopIcon) {
          <div id="m-go-to-top" class="m-go-to-top" role="scrollbar" aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" aria-controls="m-go-to-top" aria-orientation="vertical" (click)="scrollToTop()">
            <a href="javascript:void(0)" rel="noopener noreferrer">
              <span class="NeueDropdown_Active"></span>
            </a>
          </div>
        }
      </div>
    </div>
  </section>

  
  @if (universalService.showMiniPlayer) {
    <lib-audio-mini-player (audioPreviewCheck)="audioPreviewFromAnotherTab($event)"/>
  }
